import { AccessDenied, Admin, CustomRoutes, Resource } from "react-admin";
import { authProvider, dataProvider, i18nProvider } from "@/providers";
import { Dashboard, games, LoginPage, ProfilePage, vouchers } from "./pages";
import { lightTheme } from "./theme";
import { queryClient } from "./utilities";
import { QueryClientProvider } from "react-query";
import { CustomLayout } from "./components";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Route } from "react-router-dom";
import { RegisterPage } from "./pages/login/registerpage";
import { VerifyEmailPage } from "./pages/login/verifyemailpage";
import ForgotPasswordPage from "./pages/login/forgotpasswordpage";
import ResetPasswordPage from "./pages/login/resetpasswordpage";

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Admin
          dataProvider={dataProvider}
          authProvider={authProvider}
          theme={lightTheme}
          layout={CustomLayout}
          accessDenied={AccessDenied}
          loginPage={LoginPage}
          disableTelemetry={true}
          i18nProvider={i18nProvider}
          dashboard={Dashboard}
        >
          <CustomRoutes noLayout={true}>
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </CustomRoutes>

          <Resource name="games" {...games} />
          <Resource name="vouchers" {...vouchers} />
        </Admin>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};

export default App;
